import { signUp, confirmSignUp } from "aws-amplify/auth";

const CongnitoServices = {
  signUpForm: async (values, captchaToken) => {
    let phoneNumber = values.phoneNumber
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "");

    let countryCodePrefix;
    if (values.country.toLowerCase() === "india") {
      countryCodePrefix = "+91";
    } else {
      countryCodePrefix = "+1";
    }
    try {
      await signUp({
        username: values.email,
        password: values.password,
        options: {
          userAttributes: {
            email: values.email,
            name: values.name,
            phone_number: countryCodePrefix + phoneNumber,
            "custom:country": values.country,
            "custom:ZipCode": values.zipCode,
            "custom:state": values.state,
            "custom:city": values.city,
            "custom:Address": values.address,
          },
        },
        validationData: { captcha: captchaToken },
      });

      return true;
    } catch (error) {
      return error.message;

      // if (
      //   error?.message ===
      //   "PreAuthentication failed with error Recaptcha verification failed."
      // ) {
      //   window.grecaptcha.reset();
      // } else {
      //   window.grecaptcha.reset();
      // }
      // return error;
    }
  },
  verifyEmail: async (values) => {
    try {
      await confirmSignUp({
        username: values.email,
        confirmationCode: values.verificationCode,
      });
      return true;
    } catch (error) {
      return false;
    }
  },
};

export default CongnitoServices;
